/* eslint-disable react/jsx-handler-names */
import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import Toast from "../../atoms/toast";
import { requestToResetLoginSuccessfullToast } from "../../../store/slices/loginSignupSlice";
import AddonSelection from "../../organisms/addonSelection";

/**
 * CommonConditionalComponents Component
 *
 * This component handles conditional rendering of common elements.
 * @param {boolean} props.isMobile - Indicates whether the device is mobile, affecting component styling.
 * @returns {React.ReactElement} The rendered CommonConditionalComponents component.
 */
function CommonConditionalComponents({ isMobile, commonCleverTapData }) {
  const dispatch = useDispatch();
  const loginSignUpSuccessfully = useSelector((state) => state?.loginSignUp?.loginSignUpSuccessfully);
  const loginSignUpSuccessfullyText = useSelector((state) => state?.loginSignUp?.loginSignUpSuccessfullyText);

  return (
    <>
      <Toast
        variant="success"
        isToast={loginSignUpSuccessfully}
        position="fixed w-[328px] bottom-80 left-[25px] md:left-[calc(30%-81px)] lg:left-[calc(44%-54px)] xl:left-[calc(44%-54px)] 2xl:left-[calc(44%-54px)] z-10"
        header={loginSignUpSuccessfullyText}
        duration={3000}
        onToastChange={() => dispatch(requestToResetLoginSuccessfullToast())}
      />
      <AddonSelection isMobile={isMobile} commonCleverTapData={commonCleverTapData} />
    </>
  );
}

CommonConditionalComponents.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  commonCleverTapData: PropTypes.object,
};

export default CommonConditionalComponents;
